"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class SignInCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackSignInEvent(this.input);
    }
}
exports.SignInCommand = SignInCommand;
